import React, { useState } from 'react';
import { BellRing, CheckCircle2, Loader2 } from 'lucide-react';
import api from '@/lib/axios';
import { track } from '@/lib/analytics';

// Bloco 2 — Formulário público "Avise-me quando entrar uma viatura".
// Sem contas/passwords: confirma por código. Nunca envia emails reais no preview.
export default function AlertSubscribeForm({ distrito = '', finalidade = 'aluguer', tipo = '' }) {
  const [email, setEmail] = useState('');
  const [freq, setFreq] = useState('imediato');
  const [step, setStep] = useState('form'); // form | code | done
  const [codigo, setCodigo] = useState('');
  const [debugCode, setDebugCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  const subscribe = async (e) => {
    e.preventDefault();
    setLoading(true); setErr('');
    try {
      const res = await api.post('/marketplace/alerts/subscribe', {
        email: email.trim(), criterios: { distrito: distrito || null, finalidade, tipo: tipo || null }, frequencia: freq,
      });
      setDebugCode(res.data.codigo_debug || '');
      setStep('code');
    } catch (e2) { setErr(e2.response?.data?.detail || 'Não foi possível subscrever.'); }
    finally { setLoading(false); }
  };

  const confirm = async (e) => {
    e.preventDefault();
    setLoading(true); setErr('');
    try {
      await api.post('/marketplace/alerts/confirm', { email: email.trim(), codigo: codigo.trim() });
      track('create_search_alert', { distrito: !!distrito, finalidade, frequencia: freq });
      setStep('done');
    } catch (e2) { setErr(e2.response?.data?.detail || 'Código inválido.'); }
    finally { setLoading(false); }
  };

  if (step === 'done') {
    return (
      <div className="mt-4 rounded-xl border border-emerald-200 bg-emerald-50 p-4 text-center" data-testid="alert-subscribe-done">
        <CheckCircle2 className="mx-auto h-6 w-6 text-emerald-600" />
        <p className="mt-1 text-sm font-semibold text-emerald-800">Alerta ativado! Avisamos quando entrarem novas viaturas.</p>
      </div>
    );
  }

  return (
    <div className="mt-5 rounded-xl border border-slate-200 bg-slate-50 p-4 text-left" data-testid="alert-subscribe">
      <p className="inline-flex items-center gap-2 text-sm font-bold text-slate-800">
        <BellRing className="h-4 w-4 text-emerald-600" /> Avise-me quando entrar uma viatura
      </p>
      {step === 'form' ? (
        <form onSubmit={subscribe} className="mt-2 space-y-2">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="O seu email"
            className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm" data-testid="alert-subscribe-email" />
          <select value={freq} onChange={(e) => setFreq(e.target.value)}
            className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm" data-testid="alert-subscribe-freq">
            <option value="imediato">Assim que entrar</option>
            <option value="diario">Resumo diário</option>
            <option value="semanal">Resumo semanal</option>
          </select>
          <button type="submit" disabled={loading} className="inline-flex items-center gap-1.5 rounded-full bg-emerald-500 px-4 py-2 text-sm font-bold text-white hover:bg-emerald-600 disabled:opacity-60" data-testid="alert-subscribe-submit">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <BellRing className="h-4 w-4" />} Criar alerta
          </button>
        </form>
      ) : (
        <form onSubmit={confirm} className="mt-2 space-y-2">
          <p className="text-xs text-slate-500">Enviámos um código de confirmação para o seu email.{debugCode && ` (preview: ${debugCode})`}</p>
          <input value={codigo} onChange={(e) => setCodigo(e.target.value)} placeholder="Código de 6 dígitos" inputMode="numeric"
            className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm" data-testid="alert-subscribe-code" />
          <button type="submit" disabled={loading} className="inline-flex items-center gap-1.5 rounded-full bg-emerald-500 px-4 py-2 text-sm font-bold text-white hover:bg-emerald-600 disabled:opacity-60" data-testid="alert-subscribe-confirm">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <CheckCircle2 className="h-4 w-4" />} Confirmar
          </button>
        </form>
      )}
      {err && <p className="mt-2 text-xs font-semibold text-red-600" data-testid="alert-subscribe-error">{err}</p>}
      <p className="mt-2 text-[10px] text-slate-400">Sem conta nem password. Pode cancelar a qualquer momento.</p>
    </div>
  );
}
